import { render, staticRenderFns } from "./AreaProdutiva2016.vue?vue&type=template&id=416ec4e3&lang=pug"
import script from "./AreaProdutiva2016.vue?vue&type=script&lang=js"
export * from "./AreaProdutiva2016.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports